export default "__VITE_ASSET__BFhxKrTv__ 400w, __VITE_ASSET__DS38z8vk__ 800w, __VITE_ASSET__BH6w$hxw__ 1024w";